import React, { useState } from "react";
import Web3 from "web3"
import WalletConnectProvider from "@walletconnect/web3-provider"
import CoinbaseWalletSDK from '@coinbase/wallet-sdk'
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import "./index.css";

function App() {

  const networkID = 1;
  const alchemyKey = 'SwW6QQorSAwhjESmjRvf7ZuiEyxglyd6'
  const wssURL = `wss://eth-mainnet.g.alchemy.com/v2/${alchemyKey}`;
  const httpsURL = `https://eth-mainnet.g.alchemy.com/v2/${alchemyKey}`;
  const skooldayzAddress = "0x9a19AE2d56145862d8cd88FC43a36aEdA825f27a"
  const skooldayzSlug = 'skooldayz'
  const [applicationError,setApplicationError] = useState(false)
  const [chainError,setChainError] = useState(false)
  const [walletA, setWalletA] = useState(null)
  const [userWeb3, setUserWeb3] = useState()
  const [mintStarted, setMintStarted] = useState(true) //temp true
  const [totalSupply, setTTS] = useState(0)
  const [popUp, setPopUp] = useState(false)
  const [soldOut, setSoldOut] = useState(false)
  const [popUpData, setPopUpData] = useState({display: false, title: "", message: "", type: "c-loader"})

  const [loaded, setLoaded] = useState(true) //temp true

  var alchemyweb3 = createAlchemyWeb3(wssURL);
  const skooldayzABI = require("./skooldayzABI.json")
  const skooldayz = new alchemyweb3.eth.Contract(skooldayzABI,skooldayzAddress);


  window.onload = async (event) => {
    let ts = await skooldayz.methods.totalSupply().call();
    setTTS(ts);
    if (ts>=5555) {
      setSoldOut(true);
    }
    skooldayz.methods.mintStartTime().call().then((x)=>{
        if (x>0) {
          setMintStarted(true)
        }
        setLoaded(true);
    });
  };

  const connectWallet = () => {
    if (mintStarted) {
      if(typeof window.ethereum == 'undefined') {
        document.getElementById("metamask").className="walletError"
      }
      document.getElementById("walletPopUp").style.transform = "scale(1)"
      document.getElementById("walletPopUp").style.display = "flex"
    }
  }

  const connectWC = async () => {
    
    const provider = new WalletConnectProvider({ 
     infuraId: 'c69d75a96dee46dcbade741f8627bbf3',
    });

    provider.walletConnectProvider = undefined;
      await provider.enable().catch((error) => {
        if (error) {
          return
        }
      })

    const web3 = new Web3(provider)

      let chainID = await web3.eth.getChainId()

      if (chainID !== networkID){
        setChainError(true)
        await new Promise(r => setTimeout(r, 5000));
        setChainError(false)
        return
      }

      provider.on("chainChanged", chainId => {
        if (chainId !== networkID){
          setApplicationError("Application Error: Chain changed, please change back to Ethereum to continue")
        } else {
          setApplicationError(false)
        }
      });

      provider.on("accountsChanged", async (accounts) => {
        setWalletA(accounts[0])
      });

      const accounts = await web3.eth.getAccounts();

      setWalletA(accounts[0])
      setUserWeb3(web3)

      document.getElementById("walletPopUp").style.transform = "scale(0)"

      return

  }

  const connectMM = async () => {
    if (typeof window.ethereum !== 'undefined') {

      const chainID= await window.ethereum.request({ method: 'eth_chainId' });
      if ((chainID.slice(2)) !== networkID.toString()){
        setChainError(true)
        await new Promise(r => setTimeout(r, 5000));
        setChainError(false)
        return
      }

      const accounts = await window.ethereum.request({method: 'eth_requestAccounts'})


      const web3 = new Web3(window.ethereum)

      window.ethereum.on('chainChanged', chainId => {
        setApplicationError(false)
        if ((chainID.slice(2)) !== networkID){
          setApplicationError("Application Error: Chain changed, please refresh to restart")
        } else {
          setApplicationError(false)
        }
      });

      window.ethereum.on('accountsChanged', async (accounts) => {
        setWalletA(accounts[0])
      });

      setWalletA(accounts[0])
      setUserWeb3(web3)

      document.getElementById("walletPopUp").style.transform = "scale(0)"

      return

    } else {
      return
    }
  }

  const connectCBW = async () => {

    const coinbaseWallet = new CoinbaseWalletSDK({
      appName: `SKOOLDAYZ`,
      darkMode: true
    })

    const ethereum = coinbaseWallet.makeWeb3Provider(httpsURL, networkID)

    const web3 = new Web3(ethereum)

    await ethereum.enable().then((accounts) => {
  web3.eth.defaultAccount = accounts[0]
})

      const accounts = await web3.eth.getAccounts();

      ethereum.on('accountsChanged', async (accounts) => {
        setWalletA(accounts[0])
      });

      setWalletA(accounts[0])
      setUserWeb3(web3)

      document.getElementById("walletPopUp").style.transform = "scale(0)"

      return

  }


  const closePopUp = () => {
    if (popUp && popUpData.type!=="c-loader"){
      setPopUp(false)
    } 
  }

  const mint = async () => {

    if (!mintStarted) {return}

    var tweb3 = userWeb3;

    const skooldaysMintContract = new tweb3.eth.Contract(skooldayzABI,skooldayzAddress);

    let currentlyMinted = await skooldayz.methods.totalMinted(walletA)

    let mintAmount = document.getElementById("mintAmount").value

    if (mintAmount>(5-currentlyMinted)) {
      let data = popUpData
      data.title = "Mint Failed"
      data.message = `You have reached your max allowance. You have ${5-currentlyMinted} SKOOLDAY'Z left to claim.`
      data.type = "c-error"
      setPopUpData(data)
      setPopUp(true)
      return
    }
      await skooldaysMintContract.methods.mint(mintAmount).send({from: walletA, value: 0})
      .on('sending', (payload) => {
          //sending to metamask
                let data = popUpData;
      data.display = true;
      data.title = "Sending Mint Transaction"
      setPopUpData(data)
      setPopUp(true)
      })
      .on('sent', (payload) => {
              setPopUp(false)
      let data = popUpData;
      if (mintAmount>1) {
        data.title = `Minting ${mintAmount} SKOOLDAY'Z NFT'S - Cost: 0ETH`
      } else {
        data.title = `Minting a SKOOLDAY'Z NFT - Cost: 0ETH`
      }
      data.message = "Please accept the transaction in your chosen wallet"
      data.type = "c-loader"
      setPopUpData(data)
      setPopUp(true)
      })
      .on('transactionHash', (hash) => {
              setPopUp(false)
      let data = popUpData;
      data.title = "Transaction Sent"
      data.message = "Waiting for the blockchain to confirm your transaction"
      data.type = "c-loader"
      data.href = `https://etherscan.io/tx/${hash}`
      data.linkname = "View on Etherscan"
      setPopUpData(data)
      setPopUp(true)
      })
      .on('receipt', (receipt) => {
              setPopUp(false)
      let data = popUpData
        if (mintAmount>1) {
          data.message = `You have Minted ${mintAmount} SKOOLDAY'Z NFTS`
          data.href = `https://opensea.io/account/${skooldayzSlug}?search[resultModel]=ASSETS&search[sortBy]=LAST_TRANSFER_DATE`
          data.linkname = "View on opensea"
        } else {
          data.message = `You have Minted SKOOLDAY'Z #${receipt.events.Transfer.returnValues.tokenId}`
          data.href = `https://opensea.io/assets/ethereum/${skooldayzAddress}/${receipt.events.Transfer.returnValues.tokenId}`
          data.linkname = "View on opensea"
        }
      data.title = "Mint Successful"
      data.type = "c-success"
      setPopUpData(data)
      setPopUp(true)
      })
      .on('confirmation', (confirmation,receipt,latestBlockHash) => {
      })
      .on('error', (error, receipt) => {
      setPopUp(false)
      let data = popUpData
      data.title = "Mint Error"
      data.message = error.message
      data.type = "c-error"
      setPopUpData(data)
      setPopUp(true)      
    });
    
    let ts = await skooldayz.methods.totalSupply().call();
    setTTS(ts);
    if (ts>=5555) {
      setSoldOut(true);
    }

  }

  return (
    <>
      { popUp ?
    <div id="PopUp" key={popUp} onClick={closePopUp}>
      <p className="sm-txt sdark-txt">{popUpData.title}</p>

      <div className={popUpData.type}></div>

      <p className="sm-txt sdark-txt">{popUpData.message}</p>

      {popUpData.href ? <a rel="noreferrer" target="_blank"  href={popUpData.href}><p className="sm-txt sdark-txt">{popUpData.linkname}</p></a> : <></>}
    </div>
    :
    <>
    </>
  }
      { applicationError ?
    <div className="appErrorWrapper">
      <div className="appErrorPopUp">
        <p className="sm-txt col-white pd04 txt-align-c">{applicationError}</p>
      </div>
    </div>
    :
    <>
    </>
  }
    <div id="walletPopUp">
    <p className="md-txt sdark-txt">Connect with a wallet</p>
    { chainError ? <p className="sm-txt red-txt sdark-txt">Wrong Network - Change to Ethereum</p> : <></>}
    <div className="flex-center flex-gg-20 flex-se">
      <div onClick={connectMM} id="metamask" className="flex-center flex-col wallet">
        <img src="metamask.png" alt="metamask" className="walletIcon"></img>
        <p className="sm-txt txt-align-c">Metamask</p>
      </div>
       <div onClick={connectWC} className="flex-center flex-col wallet">
         <img src="walletconnect.png" alt="walletconnect" className="walletIcon"></img>
        <p className="sm-txt txt-align-c">Wallet Connect</p>
      </div>
      <div onClick={connectCBW} className="flex-center flex-col wallet">
         <img src="coinbasewallet.svg" alt="coinbasewallet" className="walletIcon"></img>
        <p className="sm-txt txt-align-c">Coinbase Wallet</p>
      </div>
    </div>
  </div>



  <div className="flex-center flex-col main">

    <div className="nav-bar">
    </div>



    

       {soldOut ? 
        <>
        <p className="lg-txt sdark-txt mgt60">SkoolDay'z Sold Out</p>
        <p className="md-txt sdark-txt">Get one on <a rel="noreferrer" target="_blank" href={`https://opensea.io/collection/${skooldayzSlug}`}>Opensea</a></p>
      </> :
      <> 
      {walletA ? <p className="sm-txt wallettxt width33 mgt60">CONNECTED WITH: {'0x'+walletA.slice(2,7).toUpperCase()+'..'+walletA.slice(35).toUpperCase()}</p> : <></>}      

      <a className="mgt20" rel="noreferrer" target="_blank" href="https://twitter.com/skooldayznft"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.543 7.85486C21.5576 8.06644 21.5576 8.27801 21.5576 8.49154C21.5576 14.9978 16.6045 22.5015 7.54759 22.5015V22.4976C4.87215 22.5015 2.25229 21.7352 0 20.2902C0.389031 20.337 0.780012 20.3604 1.17197 20.3614C3.38915 20.3633 5.54296 19.6194 7.28726 18.2495C5.18026 18.2095 3.3326 16.8357 2.68714 14.8301C3.42523 14.9725 4.18574 14.9432 4.91018 14.7453C2.61304 14.2812 0.96039 12.2629 0.96039 9.91896C0.96039 9.89751 0.96039 9.87704 0.96039 9.85656C1.64485 10.2378 2.41121 10.4494 3.19512 10.4728C1.03157 9.02682 0.364656 6.14858 1.67118 3.89824C4.17111 6.97442 7.8596 8.8445 11.8191 9.04243C11.4223 7.33225 11.9644 5.54017 13.2436 4.33798C15.2268 2.47375 18.3459 2.5693 20.2101 4.55151C21.3129 4.33408 22.3698 3.92945 23.337 3.35614C22.9694 4.49593 22.2001 5.46412 21.1725 6.07935C22.1484 5.9643 23.102 5.703 24 5.30422C23.3389 6.29483 22.5063 7.15772 21.543 7.85486Z" fill="#FFFFFF"></path></svg></a>
            <p className="sdark-txt sm-txt">Free Mint</p>
             <p className="sdark-txt md-txt">Mint A SkoolDay'z NFT</p>
      <>


      { walletA ? 
        <></> 
        : 
        <>
        {mintStarted ? <button className="purple-button mgt20 mgt60 walletBut" onClick={connectWallet}>{ mintStarted ? "CONNECT WALLET" : "MINT HAS NOT STARTED" }</button> : <></>}
        </>
      }
      <>
      {mintStarted ? <p className="sm-txt mgb20"> {totalSupply}/5555 Minted</p> : <></>}
      </>
      </>
      </>


      }



      { walletA ?

     <>

     <div className="flex-col mintSec flex-center">

        

        <div className="flex-center flex-gg-5">
          <input id="mintAmount" type="number" className="sm-input" defaultValue="1" min="1" max="5"></input>
          <button className="purple-button" onClick={mint}>Mint</button>
        </div>

      </div>

      <p id="mint-txt" className="col-white md-txt txt-align-c mgb20"></p>

     </>
      :

      <>
      </>

    }


    </div>
    { loaded ? 
      <></>
    :

    <div className="flex-center full flex-col loading">
      <div className="c-loader"></div>
      <p className="col-white md-txt">LOADING FREE MINT</p>
    </div>
    }
    </>
  );
}

export default App;
